import { Signal } from "signals";
import Logger from "slotworks/utils/logger";

class SmartUIFlags {

    public onFlagsUpdated: Signal = new Signal();

    public bitmask: number = 0;

    public init() {
        this.update();
    }

    public set(flag: SmartUIFlag, value: boolean) {
        if (value) {
            this.bitmask |= flag;
        } else {
            this.bitmask &= ~flag;
        }

        this.update();
    }

    public has(flags: SmartUIFlag | SmartUIFlag[]): boolean {
        if (Array.isArray(flags)) {
            flags = flags.reduce((all, one) => all |= one, 0);
        }
        return (this.bitmask & flags) === flags;
    }

    private update() {
        this.log(this.bitmask.toString());
        this.onFlagsUpdated.dispatch(this.bitmask);
    }

    private log(message: string) {
        Logger.info("%c SmartUIFlags ", "background: #ffccff; color: #fff", message);
    }
}

export default new SmartUIFlags();

export enum SmartUIFlag {
    ALWAYS = 0,
    IDLE = 1,
    NO_SKIP = 2,
    SKIP_COOLDOWN = 4,
    FREE_SPINS = 8,
    BONUS = 16,
    AWAITING_RESPONSE = 32,
    AUTO_SPIN = 64,
    REPLAY = 128,
    PROMPT = 256,
    MENU = 512,
    FREE_BETS = 1024,
    AUTO_SPIN_SELECT = 2048,
    GAMBLE = 4096,
    GAMBLE_UI = 8192,
    NEVER = 16384
}
